import { useAppSelector } from '../store';

export const useAuthenticatedUser = () => {
  const { user } = useAppSelector(({ auth: { user } }) => ({
    user,
  }));
  return user;
};
